import { useQuery } from '@tanstack/react-query'
import { getDomainIntelligencePortalReport } from './domainIntelligenceApi'

// On-demand fetch of the customer-facing Portal projection for a group run.
// `enabled` gates the request so the (not free) assembly only runs when the
// operator actually opens the preview.
export const usePortalPreview = (workspaceID, runPath, enabled) => {
    const {
        data: portalReport,
        isLoading: loadingPortalReport,
        error: portalReportError,
    } = useQuery({
        queryKey: ['domainIntelligencePortalReport', workspaceID, runPath],
        queryFn: () => getDomainIntelligencePortalReport(workspaceID, runPath),
        enabled: Boolean(workspaceID) && Boolean(runPath) && Boolean(enabled),
    })

    return { portalReport, loadingPortalReport, portalReportError }
}
